(function(){
  var map, markers=[], userLat=null, userLng=null, userMarker=null;
  var suggestionActive = -1;

  function dist(la1,ln1,la2,ln2){
    var R=FSL_CFG.unit==='km'?6371:3958.8;
    var dL=(la2-la1)*Math.PI/180,dN=(ln2-ln1)*Math.PI/180;
    var a=Math.sin(dL/2)*Math.sin(dL/2)+Math.cos(la1*Math.PI/180)*Math.cos(la2*Math.PI/180)*Math.sin(dN/2)*Math.sin(dN/2);
    return R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
  }
  function fmtDist(d){ var u=FSL_CFG.unit==='km'?'km':'mi'; return d<1?(d*1000).toFixed(0)+'m':d.toFixed(1)+' '+u; }

  function levenshtein(a,b){
    a=a.toLowerCase();b=b.toLowerCase();
    var m=a.length,n=b.length,dp=[];
    for(var i=0;i<=m;i++){dp[i]=[i];for(var j=1;j<=n;j++){dp[i][j]=i===0?j:(a[i-1]===b[j-1]?dp[i-1][j-1]:1+Math.min(dp[i-1][j],dp[i][j-1],dp[i-1][j-1]));}}
    return dp[m][n];
  }
  function fuzzyScore(query,target){
    if(!query||!target)return 0;
    query=query.toLowerCase().trim();target=target.toLowerCase().trim();
    if(!query)return 0;
    if(target.includes(query))return 100;
    var words=target.split(/\s+/);
    for(var i=0;i<words.length;i++){if(words[i].startsWith(query))return 80;}
    var best=0;
    for(var i=0;i<words.length;i++){var w=words[i];if(Math.abs(w.length-query.length)<=3){var lev=levenshtein(query,w);var sc=Math.round((1-lev/Math.max(query.length,w.length))*60);if(sc>best)best=sc;}}
    return best;
  }
  function storeSearchFields(s){return[s.name,s.city,s.state,s.zip,s.address];}
  function fuzzySearchStores(query){
    if(!query||!query.trim())return FSL_STORES.map(function(s){return{store:s,score:100};});
    var results=[];
    FSL_STORES.forEach(function(s){
      var best=0;
      storeSearchFields(s).forEach(function(f){if(f){var sc=fuzzyScore(query,f);if(sc>best)best=sc;}});
      if(best>=40)results.push({store:s,score:best});
    });
    results.sort(function(a,b){return b.score-a.score;});
    return results;
  }

  function buildSuggestions(query){
    var box=document.getElementById('fsl-suggestions');
    if(!query||query.trim().length<1){hideSuggestions();return;}
    var results=fuzzySearchStores(query);
    if(!results.length){box.innerHTML='<div class="fsl-no-suggestion">No stores found for "'+query+'"</div>';box.classList.add('open');return;}
    var html='';
    results.slice(0,6).forEach(function(r){
      var s=r.store;
      var sub=[s.city,s.state,s.zip?'PIN: '+s.zip:''].filter(Boolean).join(', ');
      html+='<div class="fsl-suggestion-item" data-index="'+s.index+'" onmousedown="fslPickSuggestion('+s.index+')">'
           +'<span class="fsl-suggestion-icon">🏪</span>'
           +highlightMatch(s.name,query)
           +(sub?'<span class="fsl-suggestion-sub">'+highlightMatch(sub,query)+'</span>':'')
           +'</div>';
    });
    box.innerHTML=html;box.classList.add('open');suggestionActive=-1;
  }
  function highlightMatch(text,query){
    if(!text||!query)return text||'';
    var idx=text.toLowerCase().indexOf(query.toLowerCase());
    if(idx===-1)return text;
    return text.substring(0,idx)+'<span class="fsl-suggestion-match">'+text.substring(idx,idx+query.length)+'</span>'+text.substring(idx+query.length);
  }
  function hideSuggestions(){var box=document.getElementById('fsl-suggestions');box.classList.remove('open');box.innerHTML='';suggestionActive=-1;}

  window.fslPickSuggestion=function(idx){
    var store=FSL_STORES.filter(function(s){return s.index===idx;})[0];
    if(!store)return;
    document.getElementById('fsl-input').value=store.name;
    hideSuggestions();
    FSL_STORES.forEach(function(s){
      var el=document.getElementById('fsl-item-'+s.index);
      if(el) el.style.display=s.index===idx?'':'none';
      var b=document.getElementById('fsl-dist-'+s.index);
      if(b && userLat!==null){
        b.textContent=fmtDist(dist(userLat,userLng,s.lat,s.lng));
        b.style.display=s.index===idx?'inline-block':'none';
      }
    });
    setCount(1);setStatus('Showing: '+store.name);showEmpty(false);fslSelect(idx);
  };

  function handleSuggestionKeys(e){
    var box=document.getElementById('fsl-suggestions');
    var items=box.querySelectorAll('.fsl-suggestion-item');
    if(!box.classList.contains('open')||!items.length)return;
    if(e.key==='ArrowDown'){e.preventDefault();suggestionActive=Math.min(suggestionActive+1,items.length-1);}
    else if(e.key==='ArrowUp'){e.preventDefault();suggestionActive=Math.max(suggestionActive-1,-1);}
    else if(e.key==='Enter'){if(suggestionActive>=0&&items[suggestionActive]){e.preventDefault();items[suggestionActive].dispatchEvent(new Event('mousedown'));return;}}
    else if(e.key==='Escape'){hideSuggestions();return;}
    items.forEach(function(el,i){el.classList.toggle('active',i===suggestionActive);});
  }

  function parseTime(str){if(!str)return null;var p=str.trim().split(':');return parseInt(p[0])*60+(parseInt(p[1])||0);}
  function isDayOpen(openDays){
    var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],today=new Date().getDay(),s=(openDays||'').trim();
    if(!s||s==='Daily'||s==='Everyday'||s==='Mon-Sun')return true;
    var m=s.match(/^(\w{3})\s*[-–]\s*(\w{3})$/);
    if(m){var from=days.indexOf(m[1]),to=days.indexOf(m[2]);if(from===-1||to===-1)return true;if(from<=to)return today>=from&&today<=to;return today>=from||today<=to;}
    return s.split(',').map(function(d){return d.trim();}).some(function(d){return days.indexOf(d)===today;});
  }
  function getStoreStatus(store){
    var now=new Date(),nowMins=now.getHours()*60+now.getMinutes();
    var openMins=parseTime(store.open_time),closeMins=parseTime(store.close_time),dayOpen=isDayOpen(store.open_days);
    if(!openMins||!closeMins)return{status:'unknown',label:'',subtext:'',class:''};
    var fmt=function(m){var h=Math.floor(m/60),mn=m%60,ap=h>=12?'PM':'AM';h=h%12||12;return h+(mn?':'+('0'+mn).slice(-2):'')+' '+ap;};
    if(!dayOpen)return{status:'closed',label:'Closed Today',subtext:'Opens '+store.open_days,class:'closed'};
    if(nowMins<openMins)return{status:'closed',label:'Closed Now',subtext:'Opens at '+fmt(openMins),class:'closed'};
    if(nowMins>=closeMins)return{status:'closed',label:'Closed Now',subtext:'Opens tomorrow at '+fmt(openMins),class:'closed'};
    var left=closeMins-nowMins;
    if(left<=30)return{status:'soon',label:'Closing Soon',subtext:'Closes at '+fmt(closeMins)+' ('+left+'m)',class:'soon'};
    return{status:'open',label:'Open Now',subtext:'Closes at '+fmt(closeMins),class:'open'};
  }
  function renderStatusBadge(store){var s=getStoreStatus(store);if(s.status==='unknown')return'';return'<span class="fsl-status-badge fsl-status-'+s.class+'"><span class="fsl-status-dot fsl-status-dot-'+s.class+'"></span>'+s.label+'</span>';}
  function renderPopupStatus(store){var s=getStoreStatus(store);if(s.status==='unknown')return'';var icon=s.status==='open'?'🟢':s.status==='soon'?'🟡':'🔴';return'<div class="fsl-popup-status fsl-popup-status-'+s.class+'">'+icon+' '+s.label+(s.subtext?' · <span style="font-weight:400;opacity:.85">'+s.subtext+'</span>':'')+'</div>';}
  function refreshAllStatuses(){
    FSL_STORES.forEach(function(store){
      var b=document.getElementById('fsl-status-badge-'+store.index),t=document.getElementById('fsl-hours-text-'+store.index),s=getStoreStatus(store);
      if(b)b.innerHTML=renderStatusBadge(store);
      if(t)t.textContent=s.subtext||'';
      if(markers[store.index])markers[store.index].getPopup().setContent(popupHTML(store));
    });
  }

  function makeIcon(store){
    var s=getStoreStatus(store);
    var color=store.featured?'#ff6600':FSL_CFG.accent;
    var ring=s.status==='open'?'#16a34a':s.status==='soon'?'#d97706':s.status==='closed'?'#dc2626':'#94a3b8';
    var W=28,H=36;
    var svg='<svg xmlns="http://www.w3.org/2000/svg" width="'+W+'" height="'+H+'" viewBox="0 0 100 130">'
      +'<path d="M50 0C27.91 0 10 17.91 10 40c0 30 40 90 40 90s40-60 40-90C90 17.91 72.09 0 50 0z" fill="'+color+'" stroke="#fff" stroke-width="4"/>'
      +'<circle cx="50" cy="40" r="22" fill="#fff" opacity="0.97"/>'
      +'<circle cx="50" cy="40" r="13" fill="'+ring+'"/>'
      +'</svg>';
    return L.divIcon({html:svg,className:'',iconSize:[W,H],iconAnchor:[W/2,H],popupAnchor:[0,-H]});
  }

  function popupHTML(store){
    var imgHTML=store.image?'<img class="fsl-popup-img" src="'+store.image+'" alt="'+store.name+'">':'';
    var dBadge=userLat!==null?'<div class="fsl-popup-dist"> '+fmtDist(dist(userLat,userLng,store.lat,store.lng))+' away</div>':'';
    var addr='<div class="fsl-popup-row"><svg fill="#ffff" width="14px" height="14px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0;margin-top:1px"><path d="M6,20 L6,14.5 C6,13.6715729 6.67157288,13 7.5,13 L10.5,13 C11.3284271,13 12,13.6715729 12,14.5 L12,20 L18.5,20 C19.3284271,20 20,19.3284271 20,18.5 L20,10.5 L21,10.5 L21,18.5 C21,19.8807119 19.8807119,21 18.5,21 L5.5,21 C4.11928813,21 3,19.8807119 3,18.5 L3,10.5 L4,10.5 L4,18.5 C4,19.3284271 4.67157288,20 5.5,20 L6,20 Z M7,20 L11,20 L11,14.5 C11,14.2238576 10.7761424,14 10.5,14 L7.5,14 C7.22385763,14 7,14.2238576 7,14.5 L7,20 Z M15,14.5 L15,16.5 C15,16.7761424 15.2238576,17 15.5,17 L16.5,17 C16.7761424,17 17,16.7761424 17,16.5 L17,14.5 C17,14.2238576 16.7761424,14 16.5,14 L15.5,14 C15.2238576,14 15,14.2238576 15,14.5 Z M14,14.5 C14,13.6715729 14.6715729,13 15.5,13 L16.5,13 C17.3284271,13 18,13.6715729 18,14.5 L18,16.5 C18,17.3284271 17.3284271,18 16.5,18 L15.5,18 C14.6715729,18 14,17.3284271 14,16.5 L14,14.5 Z M6,11 L3.5,11 C2.67157288,11 2,10.3284271 2,9.5 L2,8.6925824 C2,8.50175326 2.0364128,8.3126768 2.10728496,8.13549639 L4.03576165,3.31430466 C4.11169333,3.12447547 4.29554771,3 4.5,3 L19.5,3 C19.7044523,3 19.8883067,3.12447547 19.9642383,3.31430466 L21.892715,8.13549639 C21.9635872,8.3126768 22,8.50175326 22,8.6925824 L22,9.5 C22,10.3284271 21.3284271,11 20.5,11 L18,11 C17.6158228,11 17.2653782,10.8555732 17,10.6180533 C16.7346218,10.8555732 16.3841772,11 16,11 L13,11 C12.6158228,11 12.2653782,10.8555732 12,10.6180533 C11.7346218,10.8555732 11.3841772,11 11,11 L8,11 C7.61582278,11 7.26537825,10.8555732 7,10.6180533 C6.73462175,10.8555732 6.38417722,11 6,11 Z M4.83851648,4 L3.03576165,8.50688707 C3.0121376,8.5659472 3,8.62897269 3,8.6925824 L3,9.5 C3,9.77614237 3.22385763,10 3.5,10 L6,10 C6.27614237,10 6.5,9.77614237 6.5,9.5 L6.5,8.5 C6.5,8.22385763 6.72385763,8 7,8 C7.27614237,8 7.5,8.22385763 7.5,8.5 L7.5,9.5 C7.5,9.77614237 7.72385763,10 8,10 L11,10 C11.2761424,10 11.5,9.77614237 11.5,9.5 L11.5,8.5 C11.5,8.22385763 11.7238576,8 12,8 C12.2761424,8 12.5,8.22385763 12.5,8.5 L12.5,9.5 C12.5,9.77614237 12.7238576,10 13,10 L16,10 C16.2761424,10 16.5,9.77614237 16.5,9.5 L16.5,8.5 C16.5,8.22385763 16.7238576,8 17,8 C17.2761424,8 17.5,8.22385763 17.5,8.5 L17.5,9.5 C17.5,9.77614237 17.7238576,10 18,10 L20.5,10 C20.7761424,10 21,9.77614237 21,9.5 L21,8.6925824 C21,8.62897269 20.9878624,8.5659472 20.9642383,8.50688707 L19.1614835,4 L4.83851648,4 Z"/></svg> '+store.address+(store.city?', '+store.city:'')+'</div>';
    var zip=store.zip?'<div class="fsl-popup-row"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="white" stroke="#ffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:1px"><path d="M12 21v-7"/><path d="M9 3v5l-2 4v2h10m0 0h-5m5 0v-2l-2-4V3"/><path d="M7 3h10"/></svg> PIN: '+store.zip+'</div>':'';
    var phone=store.phone?'<div class="fsl-popup-row"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 32 32" fill="white" stroke="white" style="flex-shrink:0;margin-top:1px"><path d="M23.407 30.394c-2.431 0-8.341-3.109-13.303-9.783-4.641-6.242-6.898-10.751-6.898-13.785 0-2.389 1.65-3.529 2.536-4.142l0.219-0.153c0.979-0.7 2.502-0.927 3.086-0.927 1.024 0 1.455 0.599 1.716 1.121 0.222 0.442 2.061 4.39 2.247 4.881 0.286 0.755 0.192 1.855-0.692 2.488l-0.155 0.108c-0.439 0.304-1.255 0.869-1.368 1.557-0.055 0.334 0.057 0.684 0.342 1.068 1.423 1.918 5.968 7.55 6.787 8.314 0.642 0.6 1.455 0.685 2.009 0.218 0.573-0.483 0.828-0.768 0.83-0.772l0.059-0.057c0.048-0.041 0.496-0.396 1.228-0.396 0.528 0 1.065 0.182 1.596 0.541 1.378 0.931 4.487 3.011 4.487 3.011l0.050 0.038c0.398 0.341 0.973 1.323 0.302 2.601-0.695 1.327-2.85 4.066-5.079 4.066zM9.046 2.672c-0.505 0-1.746 0.213-2.466 0.728l-0.232 0.162c-0.827 0.572-2.076 1.435-2.076 3.265 0 2.797 2.188 7.098 6.687 13.149 4.914 6.609 10.532 9.353 12.447 9.353 1.629 0 3.497-2.276 4.135-3.494 0.392-0.748 0.071-1.17-0.040-1.284-0.36-0.241-3.164-2.117-4.453-2.988-0.351-0.238-0.688-0.358-0.999-0.358-0.283 0-0.469 0.1-0.532 0.14-0.104 0.111-0.39 0.405-0.899 0.833-0.951 0.801-2.398 0.704-3.424-0.254-0.923-0.862-5.585-6.666-6.916-8.459-0.46-0.62-0.641-1.252-0.538-1.877 0.187-1.133 1.245-1.866 1.813-2.26l0.142-0.099c0.508-0.363 0.4-1.020 0.316-1.242-0.157-0.414-1.973-4.322-2.203-4.781-0.188-0.376-0.336-0.533-0.764-0.533z"/></svg> <a href="tel:'+store.phone+'" style="color:inherit">'+store.phone+'</a></div>':'';

    // ✅ Original directions link — lat/lng completely untouched
    var dir='https://www.google.com/maps/dir/?api=1&destination='+store.lat+','+store.lng;

    // ✅ New View on Map button — only shows if map_link is filled in customizer
    var mapLinkBtn=(store.map_link && store.map_link.trim())
      ?'<a class="fsl-popup-btn fsl-popup-btn-map" href="'+store.map_link+'" target="_blank">📍 View on Map</a>'
      :'';

    var wa=store.phone?'https://wa.me/'+store.phone.replace(/[^0-9]/g,''):null;

    return'<div class="fsl-popup">'+imgHTML
      +'<div class="fsl-popup-header">'+(store.featured?'<div style="font-size:10px;font-weight:800;opacity:.85;margin-bottom:2px">⭐ FEATURED</div>':'')
      +'<p class="fsl-popup-name">'+store.name+'</p>'
      +(store.city?'<p class="fsl-popup-city">'+store.city+(store.state?', '+store.state:'')+'</p>':'')
      +'</div><div class="fsl-popup-body">'+renderPopupStatus(store)+addr+zip+phone+dBadge
      +'<div class="fsl-popup-actions">'
      +'<a class="fsl-popup-btn fsl-popup-btn-main" href="'+dir+'" target="_blank">Directions →</a>'
      +mapLinkBtn
      +(wa?'<a class="fsl-popup-btn fsl-popup-btn-wa" href="'+wa+'" target="_blank">WhatsApp</a>':'')
      +'</div></div></div>';
  }

  function updateAllDistanceBadges(visibleIndexes){
    if(userLat===null)return;
    FSL_STORES.forEach(function(s){
      var b=document.getElementById('fsl-dist-'+s.index);
      if(!b)return;
      b.textContent=fmtDist(dist(userLat,userLng,s.lat,s.lng));
      b.style.display=(!visibleIndexes||visibleIndexes.indexOf(s.index)!==-1)?'inline-block':'none';
    });
  }

  function init(){
    map=L.map('fsl-map',{zoomControl:true,tap:false}).setView([22.5,80.0],5);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'© OpenStreetMap',maxZoom:19}).addTo(map);
    addMarkers();
    refreshAllStatuses();
    setInterval(refreshAllStatuses,60000);
    setTimeout(function(){map.invalidateSize();},300);
    setTimeout(function(){map.invalidateSize();},800);
    window.addEventListener('resize',function(){map.invalidateSize();});
  }

  function addMarkers(){
    markers.forEach(function(m){m.remove();});markers=[];
    FSL_STORES.forEach(function(s){
      var m=L.marker([s.lat,s.lng],{icon:makeIcon(s)}).addTo(map);
      m.bindPopup(popupHTML(s),{maxWidth:280});
      m.on('click',function(){fslSelect(s.index,false);});
      markers.push(m);
    });
  }

  function fitAll(stores){
    if(!stores.length)return;
    if(stores.length===1){map.setView([stores[0].lat,stores[0].lng],14);return;}
    var bounds=L.latLngBounds(stores.map(function(s){return[s.lat,s.lng];}));
    map.fitBounds(bounds,{padding:[60,60],maxZoom:14,minZoom:5});
  }

  window.fslSelect=function(idx,fly){
    document.querySelectorAll('.fsl-item').forEach(function(e){e.classList.remove('active');});
    var el=document.getElementById('fsl-item-'+idx);
    if(el){el.classList.add('active');el.scrollIntoView({block:'nearest',behavior:'smooth'});}
    if(markers[idx]){
      if(fly!==false)map.setView([FSL_STORES[idx].lat,FSL_STORES[idx].lng],15,{animate:true});
      markers[idx].getPopup().setContent(popupHTML(FSL_STORES[idx]));
      markers[idx].openPopup();
    }
  };

  window.fslNearMe=function(){
    if(!navigator.geolocation){alert('Geolocation not supported.');return;}
    var btn=document.getElementById('fsl-geo-btn');
    btn.classList.add('on');
    btn.innerHTML=' <span>Locating…</span>';
    var done=false;
    function applyLocation(lat,lng){
      userLat=lat;userLng=lng;
      if(userMarker)userMarker.remove();
      var dot=document.createElement('div');dot.className='fsl-user-dot';
      userMarker=L.marker([userLat,userLng],{icon:L.divIcon({html:dot,className:'',iconSize:[16,16],iconAnchor:[8,8]})}).addTo(map);
      var nearby=FSL_STORES.filter(function(s){return dist(userLat,userLng,s.lat,s.lng)<=FSL_CFG.radius;})
        .sort(function(a,b){return dist(userLat,userLng,a.lat,a.lng)-dist(userLat,userLng,b.lat,b.lng);});
      var nearbyIndexes=nearby.map(function(s){return s.index;});
      FSL_STORES.forEach(function(s){
        var it=document.getElementById('fsl-item-'+s.index);
        if(it)it.style.display=nearbyIndexes.indexOf(s.index)!==-1?'':'none';
      });
      updateAllDistanceBadges(nearbyIndexes);
      setCount(nearby.length);
      setStatus(nearby.length+' store'+(nearby.length!==1?'s':'')+' near you');
      showEmpty(nearby.length===0);
      var pts=nearby.map(function(s){return[s.lat,s.lng];});pts.push([userLat,userLng]);
      if(nearby.length)map.fitBounds(pts,{padding:[40,40]});else map.setView([userLat,userLng],10);
      if(nearby.length)fslSelect(nearby[0].index,false);
      btn.innerHTML=' <span>Near Me</span>';
    }
    navigator.geolocation.getCurrentPosition(
      function(p){if(!done){done=true;applyLocation(p.coords.latitude,p.coords.longitude);}},
      function(){},{timeout:3000,maximumAge:60000,enableHighAccuracy:false}
    );
    navigator.geolocation.getCurrentPosition(
      function(p){applyLocation(p.coords.latitude,p.coords.longitude);done=true;},
      function(){btn.innerHTML='📍 <span>Near Me</span>';btn.classList.remove('on');if(!done)alert('Could not get location. Please allow location access.');},
      {timeout:10000,maximumAge:0,enableHighAccuracy:true}
    );
  };

  window.fslSearch=function(){
    var q=document.getElementById('fsl-input').value.trim();
    hideSuggestions();
    if(!q){resetList();return;}
    var results=fuzzySearchStores(q),found=results.map(function(r){return r.store;});
    var foundIndexes=found.map(function(s){return s.index;});
    FSL_STORES.forEach(function(s){
      var el=document.getElementById('fsl-item-'+s.index);
      if(el) el.style.display=foundIndexes.indexOf(s.index)!==-1?'':'none';
    });
    updateAllDistanceBadges(foundIndexes);
    setCount(found.length);
    setStatus(found.length+' result'+(found.length!==1?'s':'')+' for "'+q+'"');
    showEmpty(found.length===0);
    if(found.length){fitAll(found);if(found.length===1)fslSelect(found[0].index);}
  };

  function resetList(){
    FSL_STORES.forEach(function(s){
      var el=document.getElementById('fsl-item-'+s.index);
      if(el) el.style.display='';
    });
    updateAllDistanceBadges(null);
    setCount(FSL_STORES.length);
    setStatus(FSL_STORES.length+' store'+(FSL_STORES.length!==1?'s':'')+' available');
    showEmpty(false);
    map.setView([22.5,80.0],5);
  }

  function setCount(n){document.getElementById('fsl-count').textContent=n;}
  function setStatus(t){document.getElementById('fsl-status').textContent=t;}
  function showEmpty(s){document.getElementById('fsl-empty').style.display=s?'block':'none';}

  document.addEventListener('DOMContentLoaded',function(){
    var input=document.getElementById('fsl-input');
    if(input){
      input.addEventListener('input',function(){buildSuggestions(this.value.trim());});
      input.addEventListener('keydown',function(e){if(e.key==='Enter'){fslSearch();hideSuggestions();}else handleSuggestionKeys(e);});
      document.addEventListener('click',function(e){if(!e.target.closest('#fsl-suggestions')&&e.target!==input)hideSuggestions();});
    }
    init();
    if(navigator.geolocation){
      navigator.geolocation.getCurrentPosition(function(p){
        userLat=p.coords.latitude;
        userLng=p.coords.longitude;
        updateAllDistanceBadges(null);
        FSL_STORES.forEach(function(s){
          if(markers[s.index])markers[s.index].getPopup().setContent(popupHTML(s));
        });
      },function(){},{timeout:8000,enableHighAccuracy:false});
    }
  });
})();